var Rep = Backbone.Model.extend({
    defaults: {
        'name' : '',
        'company' : '',
        'email' : '',
        'description' : '',
        'country' : null,
        'state' : null
    }
});
export {Rep};